import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../lib/api.js";

export default function PerfilTab() {
  const [form, setForm] = useState({ name: "", phone: "", address: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      setErr(""); setMsg("");
      try {
        // Backend: GET /api/me -> { user: { name, phone, address } }
        const r = await apiGet("/api/me");
        setForm({
          name: r?.user?.name || "",
          phone: r?.user?.phone || "",
          address: r?.user?.address || ""
        });
      } catch {
        setErr("Falha ao carregar dados do perfil.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function onSave(e) {
    e.preventDefault();
    setSaving(true); setErr(""); setMsg("");
    try {
      // Backend: POST /api/me/profile { name, phone, address }
      await apiPost("/api/me/profile", form);
      setMsg("Perfil atualizado com sucesso.");
    } catch {
      setErr("Não foi possível guardar as alterações.");
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="py-3">A carregar…</div>;

  return (
    <form className="row g-3" onSubmit={onSave} style={{maxWidth: 680}}>
      <div className="col-12">
        <label className="form-label">Nome</label>
        <input className="form-control" value={form.name}
               onChange={(e)=>setForm({...form, name: e.target.value})}/>
      </div>
      <div className="col-sm-6">
        <label className="form-label">Telefone</label>
        <input className="form-control" value={form.phone}
               onChange={(e)=>setForm({...form, phone: e.target.value})}/>
      </div>
      <div className="col-12">
        <label className="form-label">Morada</label>
        <textarea className="form-control" rows={3} value={form.address}
                  onChange={(e)=>setForm({...form, address: e.target.value})}/>
      </div>

      {msg && <div className="text-success">{msg}</div>}
      {err && <div className="text-danger">{err}</div>}

      <div className="col-12">
        <button className="btn btn-primary" disabled={saving}>
          {saving ? "A guardar…" : "Guardar alterações"}
        </button>
      </div>
    </form>
  );
}
